define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/xml"
], function(declare,_,Controller,xml) {

	return declare(Controller, {
		toWriter: function() {
			// summary: create new request for each selected company
			_.each(this.m_formData.getSelectedNodes(true), function(node) {
				this._writeRequest().addParameter(xml.PROP_URL, xml.ATTR_REF, node.$URL);
			}, this);
		}
	});
});